<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Event" childName="Design"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading :title="'Design'"></heading>
        <div class="grid-view">
          <div class="grid-element">
            <img :src="require('../assets/img/template1.png')" />
            <div class="grid-actions">
              <span>Preview</span>
              <span class="black">|</span>
              <span>Activate</span>
            </div>
          </div>
            <div class="grid-element">
            <img :src="require('../assets/img/template2.png')" />
            <div class="grid-actions">
              <span>Preview</span>
              <span class="black">|</span>
              <span>Activate</span>
            </div>
          </div>
            <div class="grid-element">
            <img :src="require('../assets/img/template3.png')" />
            <div class="grid-actions">
              <span>Preview</span>
              <span class="black">|</span>
              <span>Activate</span>
            </div>
          </div>
            <div class="grid-element">
            <img :src="require('../assets/img/template4.png')" />
            <div class="grid-actions">
              <span>Preview</span>
              <span class="black">|</span>
              <span>Activate</span>
            </div>
          </div>
            <div class="grid-element">
            <img :src="require('../assets/img/template5.png')" />
            <div class="grid-actions">
              <span>Preview</span>
              <span class="black">|</span>
              <span>Activate</span>
            </div>
          </div>
        </div>
      </div>
      <div class="contain"></div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import Upload from "@/components/Upload.vue";
import Popup from "@/components/Popup.vue";

import { Datetime } from "vue-datetime";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");
export default {
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    datetime: Datetime,
    heading: Title,
    popup: Popup,
    upload: Upload
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.grid-view {
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .grid-element {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 23%;
    flex-direction: column;
    margin-bottom: 45px;
    img {
      width: 100%;
    }
    .grid-actions {
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding: 10px 0;
      span {
        color: #fba500;
        &.black {
          color: black;
        }
      }
    }
  }
}
</style>